export const REGION_OPTIONS = [
  {
    id: '1',
    label: 'yerevan.label'
  },
  {
    id: '2',
    label: 'kotayk.label'
  },
  {
    id: '3',
    label: 'lori.label'
  },
  {
    id: '4',
    label: 'shirak.label'
  },
  {
    id: '5',
    label: 'ararat.label'
  },
  {
    id: '6',
    label: 'gegharkunik.label'
  },
  {
    id: '7',
    label: 'armavir.label'
  }
]

export const BRANCH_DATA = [
  {
    id: '10',
    cord: [40.209607, 44.530513],
    city: 'branch10.city',
    days: {
      monFry: 'branch10.days.monFry.text',
      satSun: 'branch10.days.satSun.text'
    },
    hours: {
      monFry: 'branch10.days.monFry.hours',
      satSun: 'branch10.days.satSun.hours'
    },
    street: 'branch10.street',
    region: {
      id: 'yerevan.id',
      label: 'yerevan.label'
    }
  },
  {
    id: '1',
    cord: [40.196706, 44.565861],
    phone: '+37495288221',
    city: 'branch1.city',
    days: {
      monFry: 'branch1.days.monFry.text',
      satSun: 'branch1.days.satSun.text'
    },
    hours: {
      monFry: 'branch1.days.monFry.hours',
      satSun: 'branch1.days.satSun.hours'
    },
    street: 'branch1.street',
    region: {
      id: 'yerevan.id',
      label: 'yerevan.label'
    }
  },
  {
    id: '2',
    cord: [40.206225, 44.518269],
    city: 'branch2.city',
    days: {
      monFry: 'branch2.days.monFry.text',
      satSun: 'branch2.days.satSun.text'
    },
    hours: {
      monFry: 'branch2.days.monFry.hours',
      satSun: 'branch2.days.satSun.hours'
    },
    street: 'branch2.street',
    region: {
      id: 'yerevan.id',
      label: 'yerevan.label'
    }
  },
  {
    id: '3',
    cord: [40.208464, 44.4679],
    city: 'branch3.city',
    days: {
      monFry: 'branch3.days.monFry.text',
      satSun: 'branch3.days.satSun.text'
    },
    hours: {
      monFry: 'branch3.days.monFry.hours',
      satSun: 'branch3.days.satSun.hours'
    },
    street: 'branch3.street',
    region: {
      id: 'yerevan.id',
      label: 'yerevan.label'
    }
  },
  {
    id: '4',
    cord: [40.150288, 44.483486],
    city: 'branch4.city',
    days: {
      monFry: 'branch4.days.monFry.text',
      satSun: 'branch4.days.satSun.text'
    },
    hours: {
      monFry: 'branch4.days.monFry.hours',
      satSun: 'branch4.days.satSun.hours'
    },
    street: 'branch4.street',
    region: {
      id: 'yerevan.id',
      label: 'yerevan.label'
    }
  },
  {
    id: '5',
    cord: [40.141802, 44.520631],
    city: 'branch5.city',
    days: {
      monFry: 'branch5.days.monFry.text',
      satSun: 'branch5.days.satSun.text'
    },
    hours: {
      monFry: 'branch5.days.monFry.hours',
      satSun: 'branch5.days.satSun.hours'
    },
    street: 'branch5.street',
    region: {
      id: 'yerevan.id',
      label: 'yerevan.label'
    }
  },
  {
    id: '6',
    cord: [40.184112, 44.514595],
    city: 'branch6.city',
    days: {
      monFry: 'branch6.days.monFry.text',
      satSun: 'branch6.days.satSun.text'
    },
    hours: {
      monFry: 'branch6.days.monFry.hours',
      satSun: 'branch6.days.satSun.hours'
    },
    street: 'branch6.street',
    region: {
      id: 'yerevan.id',
      label: 'yerevan.label'
    }
  },
  {
    id: '7',
    cord: [40.178586, 44.510552],
    city: 'branch7.city',
    days: {
      monFry: 'branch7.days.monFry.text',
      satSun: 'branch7.days.satSun.text'
    },
    hours: {
      monFry: 'branch7.days.monFry.hours',
      satSun: 'branch7.days.satSun.hours'
    },
    street: 'branch7.street',
    region: {
      id: 'yerevan.id',
      label: 'yerevan.label'
    }
  },
  {
    id: '8',
    cord: [40.173797, 44.446394],
    city: 'branch8.city',
    days: {
      monFry: 'branch8.days.monFry.text',
      satSun: 'branch8.days.satSun.text'
    },
    hours: {
      monFry: 'branch8.days.monFry.hours',
      satSun: 'branch8.days.satSun.hours'
    },
    street: 'branch8.street',
    region: {
      id: 'yerevan.id',
      label: 'yerevan.label'
    }
  },
  {
    id: '9',
    cord: [40.170069, 44.513876],
    city: 'branch9.city',
    days: {
      monFry: 'branch9.days.monFry.text',
      satSun: 'branch9.days.satSun.text'
    },
    hours: {
      monFry: 'branch9.days.monFry.hours',
      satSun: 'branch9.days.satSun.hours'
    },
    street: 'branch9.street',
    region: {
      id: 'yerevan.id',
      label: 'yerevan.label'
    }
  },
  {
    id: '11',
    cord: [40.216101, 44.578761],
    city: 'branch11.city',
    days: {
      monFry: 'branch11.days.monFry.text',
      satSun: 'branch11.days.satSun.text'
    },
    hours: {
      monFry: 'branch11.days.monFry.hours',
      satSun: 'branch11.days.satSun.hours'
    },
    street: 'branch11.street',
    region: {
      id: 'yerevan.id',
      label: 'yerevan.label'
    }
  },
  {
    id: '12',
    cord: [40.270676, 44.626471],
    city: 'branch12.city',
    days: {
      monFry: 'branch12.days.monFry.text',
      satSun: 'branch12.days.satSun.text'
    },
    hours: {
      monFry: 'branch12.days.monFry.hours',
      satSun: 'branch12.days.satSun.hours'
    },
    street: 'branch12.street',
    region: {
      id: 'kotayk.id',
      label: 'kotayk.label'
    }
  },
  {
    id: '13',
    cord: [40.547739, 44.955296],
    city: 'branch13.city',
    days: {
      monFry: 'branch13.days.monFry.text',
      satSun: 'branch13.days.satSun.text'
    },
    hours: {
      monFry: 'branch13.days.monFry.hours',
      satSun: 'branch13.days.satSun.hours'
    },
    street: 'branch13.street',
    region: {
      id: 'gegharkunik.id',
      label: 'gegharkunik.label'
    }
  },
  {
    id: '14',
    cord: [40.808989, 44.49281],
    city: 'branch14.city',
    days: {
      monFry: 'branch14.days.monFry.text',
      satSun: 'branch14.days.satSun.text'
    },
    hours: {
      monFry: 'branch14.days.monFry.hours',
      satSun: 'branch14.days.satSun.hours'
    },
    street: 'branch14.street',
    region: {
      id: 'lori.id',
      label: 'lori.label'
    }
  },
  {
    id: '15',
    cord: [40.787594, 43.848161],
    city: 'branch15.city',
    days: {
      monFry: 'branch15.days.monFry.text',
      satSun: 'branch15.days.satSun.text'
    },
    hours: {
      monFry: 'branch15.days.monFry.hours',
      satSun: 'branch15.days.satSun.hours'
    },
    street: 'branch15.street',
    region: {
      id: 'shirak.id',
      label: 'shirak.label'
    }
  },
  {
    id: '16',
    cord: [39.956583, 44.545083],
    city: 'branch16.city',
    days: {
      monFry: 'branch16.days.monFry.text',
      satSun: 'branch16.days.satSun.text'
    },
    hours: {
      monFry: 'branch16.days.monFry.hours',
      satSun: 'branch16.days.satSun.hours'
    },
    street: 'branch16.street',
    region: {
      id: 'ararat.id',
      label: 'ararat.label'
    }
  },
  {
    id: '17',
    cord: [40.203284, 44.500599],
    city: 'branch17.city',
    days: {
      monFry: 'branch17.days.monFry.text',
      satSun: 'branch17.days.satSun.text'
    },
    hours: {
      monFry: 'branch17.days.monFry.hours',
      satSun: 'branch17.days.satSun.hours'
    },
    street: 'branch17.street',
    region: {
      id: 'yerevan.id',
      label: 'yerevan.label'
    }
  },
  {
    id: '18',
    cord: [40.163239, 44.294238],
    city: 'branch18.city',
    days: {
      monFry: 'branch18.days.monFry.text',
      satSun: 'branch18.days.satSun.text'
    },
    hours: {
      monFry: 'branch18.days.monFry.hours',
      satSun: 'branch18.days.satSun.hours'
    },
    street: 'branch18.street',
    region: {
      id: 'armavir.id',
      label: 'armavir.label'
    }
  }
]
